import http from '../../utils/axios'
import Vue from 'vue'
import iView from 'iview'
Vue.use(iView)
const product = {
    state: {
        productlist: [],
        totalcount: 1,
        bu: [],
        productLine: [],
        brand: [],
        productType: [],
        buCascader: [],
        editProduct: null,
        productAnotherList: [],
        productTotal: 1,
        defaultProductBatchNumber: null
    },
    mutations: {
        QueryProduct (state, data) {
            state.productlist = data.Models
            state.totalcount = data.TotalCount
        },
        QueryBU (state, data) {
            state.bu = data
        },
        QueryBUCascader (state, data) {
            state.buCascader = data
        },
        GetProduct (state, data) {
            state.editProduct = data
        },
        QueryProductAnother (state, data) {
            state.productAnotherList = data.Models
            state.productTotal = data.TotalCount
        },
        RefurbishBatchNumber (state, data) {
            state.defaultProductBatchNumber = data + '_Default'
        }
    },
    actions: {
        queryProduct ({
            commit
        }, params) {
            http.get(process.env.COREAPI_HOST +'/Product/QueryProduct', {
                params: params
            }).then(response =>
                commit('QueryProduct', response.data)
            )
        },
        queryBUCascader ({
            commit
        }) {
            http.get(process.env.COREAPI_HOST + '/Product/GetBUCascader').then(response =>
                commit('QueryBUCascader', response.data)
            )
        },
        getProduct ({
            commit
        }, params) {
            http.get(process.env.COREAPI_HOST + '/Product/GetProduct', {
                params: params
            }).then(response =>
                commit('GetProduct', response.data)
            )
        },
        queryProductAnother ({
            commit
        }, params) {
            http.get(process.env.COREAPI_HOST + '/Product/QueryProductAnother', {
                params: params
            }).then(response =>
                commit('QueryProductAnother', response.data)
            )
        }
    }
}
export default product



// WEBPACK FOOTER //
// ./src/store/modules/product.js